const accordionStyles = (tokens) => ({
    variants: {
        form: {
            button: {
                borderRadius: tokens.BorderRadius02,
                background: tokens.CanvasPrimary200,
                pa: tokens.Spacing04,
                height: '44px',
                _expanded: {
                    bg: tokens.CanvasPrimary300,
                },
                _focus: {
                    bgColor: `${tokens.CanvasPrimary300} !important`,
                },
                _hover: {
                    bg: tokens.CanvasPrimary200,
                },
            },
            container: {
                w: '100%',
            },
            panel: {
                padding: 0,
                'padding-top': tokens.Spacing05,
                'padding-bottom': tokens.Spacing02,
                marginX: tokens.Spacing02,
            },
        },
        white: {
            container: {
                boxShadow: '0 2px 4px 0px rgba(26, 26, 26, 0.20)',
                borderRadius: tokens.BorderRadius02,
                overflow: 'hidden',
            },
            button: {
                height: '60px',
                borderRadius: 'inherit',
                background: tokens.Layer01,
                width: '100%',
                py: 2,
                _hover: {
                    background: tokens.Layer01,
                },
            },
            panel: {
                background: tokens.Layer01,
                paddingBottom: tokens.Spacing05,
                borderRadius: tokens.BorderRadius02,
                paddingTop: '0px',
            },
        },
    },
});
export default accordionStyles;
